<template>
    <div>
        <h2>This is Nursing Header Section</h2>
    </div>
</template>
  
<script>
  export default {
    name: 'NursingHeader'
  }
</script>
  
<style scoped>
  
</style>